import { useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHashElement = () => {
  let location = useLocation();

  let hashElement = useMemo(() => {
    let hash = location.hash;
    const removeHashCharacter = (str) => {
      const result = str.slice(1);
      return result;
    };

    if (hash) {
      let element = document.getElementById(removeHashCharacter(hash));
      return element;
    } else {
      return null;
    }
  }, [location]);

  useEffect(() => {
    if (!hashElement) return;
    /* Defer one frame so App route scroll and layout paint settle (e.g. /treydorex → /#sales). */
    const id = window.requestAnimationFrame(() => {
      hashElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
    return () => window.cancelAnimationFrame(id);
  }, [hashElement]);

  return null;
};

export default ScrollToHashElement;